export default __webpack_public_path__ + "static/media/certificates45001.74039d21.png";